export enum AppRoute {
  Home = 'routes.home',
  Summary = 'routes.summary'
}

export const AppRouteTitles = new Map([
  [AppRoute.Home, 'home.title'],
  [AppRoute.Summary, 'summary.title']
]);
